<div class="bg-m0 flex h-[700px] select-none flex-col p-9">
  <div
    data-cy="addTileDialogTitle"
    class="text-s2 mt-5 text-left text-2xl font-semibold"
    >Add Tile</div
  >

  <div class="text-s1 mt-9 text-lg"
    >To add a tile to dashboard, go to the Models page, select a chart, click
    "Save As" and select "Tile of Dashboard"</div
  >

  <div class="text-s2 mb-3 mt-9 text-lg font-semibold">Models:</div>

  <div
    class="flex flex-1 flex-shrink-0 flex-row items-center justify-center"
    *ngIf="!models"
  >
    <div class="relative flex h-9 w-9">
      <ngx-spinner
        [name]="spinnerName"
        color="#0084d1"
        bdColor="#00000000"
        size="default"
        type="ball-clip-rotate"
        [fullScreen]="false"
        [disableAnimation]="true"
        [zIndex]="10"
      >
      </ngx-spinner>
    </div>
  </div>

  <div class="overflow-y-auto" *ngIf="!!models">
    <div
      class="text-s1 hover:bg-m50 rounded py-[10px] pl-5 text-base hover:cursor-pointer"
      *ngFor="let model of models"
      (click)="navToModel(model.modelId)"
    >
      {{ model.label }}

      <span class="text-s400 ml-[5px]">- {{ model.connectionType }}</span>
    </div>
  </div>
</div>
